import { ID } from "common/entities/IEntity";
import { Entity, Field } from "typegraph";
import entityMeta from "panels/kb/entityMeta";
import { Input } from "decorator-form";
import Product from "./Product";
import InputType from "common/form/InputType";

function mapParams(data) {
	const params = { ...data }; //clone

	return { params: params };
}
class Contributor {
	@Field()
	public id: ID;

	@Field()
	public name: string;

	@Field()
	public avatarUrl: string;

	@Field()
	public designations: string;

	@Field()
	public description: string;

	@Field()
	public imageURL: string;

}

@Entity(entityMeta.PRODUCTCONTRIBUTOR)
export class ProductContributor {
	@Field()
	public id: ID;

	@Field({ entity: Contributor })
	public contributor: null | Contributor[];
}
@Entity(entityMeta.PRODUCTCONTRIBUTOR)
export class ContributorCatalog {
	@Field()
	public id: ID;

	@Field({ entity: Product })
	public product: null | Product[];
}



// WEBPACK FOOTER //
// ./src/panels/catalog/entities/ProductContributor.ts